import { type EmployeeStatusInCompany } from 'src/old/api/types';
import { type LatamBankAccountType, type LatamDocumentType } from 'src/modules/DataReview/ReviewTable/Request/types';

export enum DataConfirmationStatus {
  AWAITS_CONFIRMATION = 'awaitsConfirmation',
  PENDING_REVIEW = 'pendingReview',
  ADMIN_APPROVED = 'adminApproved',
  USER_APPROVED = 'userApproved'
}

export enum AdminReviewStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  WAITING = 'waiting'
}

export type ChangeFieldRequest = {
  fieldName: string;
  adminReviewStatus: AdminReviewStatus;
  newValue: string;
};

export type DataConfirmation = {
  requestedAt: Date;
  adminApprovalId?: number;
  approvedAt?: Date;
  changesRequested: ChangeFieldRequest[];
};

export type EmployeeRequestedDataChange = {
  bankAccountNumber: string;
  bankAccountType: LatamBankAccountType;
  dataConfirmation: DataConfirmation;
  bankEntity: string;
  dataConfirmationStatus: DataConfirmationStatus;
  subsidiary?: {
    taxId: string;
  };
  documentType: LatamDocumentType;
  firstName: string;
  id: number;
  lastName: string;
  payrollId: string;
  personalId: string;
  status: EmployeeStatusInCompany;
};

export type EmployeeRequestedDataChangeToDisplay = Omit<
  EmployeeRequestedDataChange,
  | 'dataConfirmation'
  | 'dataConfirmationStatus'
  | 'subsidiaryTaxId'
  | 'firstName'
  | 'lastName'
  | 'id'
  | 'payrollId'
  | 'status'
>;

export type PaginatedResponseWithTotalCompanyPendingRequests<T> = {
  data: T[];
  meta: {
    totalItems: number;
    currentPage: number;
    totalPages: number;
    totalCompanyPendingRequests: number;
  };
};
